(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("9e4lR", function(module, exports) {
    $parcel$export(module.exports, "MODAL_OPEN_REQUEST_EVENT", function() {
      return $6b78cbfbaadac19a$export$3a3ec5884c2bdab0;
    });
    $parcel$export(module.exports, "MODAL_OPENED_EVENT", function() {
      return $6b78cbfbaadac19a$export$16a5d99daeabc70f;
    });
    $parcel$export(module.exports, "MODAL_OPEN_FAILED_EVENT", function() {
      return $6b78cbfbaadac19a$export$3e10ac5c14d1b477;
    });
    $parcel$export(module.exports, "createModalRequestId", function() {
      return $6b78cbfbaadac19a$export$6966a06f04e186a1;
    });
    const $6b78cbfbaadac19a$export$3a3ec5884c2bdab0 = "mbf:modal-open-request";
    const $6b78cbfbaadac19a$export$16a5d99daeabc70f = "mbf:modal-opened";
    const $6b78cbfbaadac19a$export$3e10ac5c14d1b477 = "mbf:modal-open-failed";
    function $6b78cbfbaadac19a$export$6966a06f04e186a1() {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    function $6b78cbfbaadac19a$export$dee6409cd6d872a1(detail = {}) {
      const {requestId: requestId = null, baseUrl: baseUrl = null, url: url = null, view: view = null, strategy: strategy = null, context: context = null, modalId: modalId = null, source: source = null} = detail;
      return {
        requestId: requestId,
        baseUrl: baseUrl,
        url: url,
        view: view,
        strategy: strategy,
        context: context,
        modalId: modalId,
        sourceType: source?.type || null,
        sourceId: source?.id || null
      };
    }
  });
  parcelRegister("hdTUn", function(module, exports) {
    $parcel$export(module.exports, "getModalOrchestratorReadiness", function() {
      return $c89f04cac0ca9284$export$b6ddc94bcaaa5fb;
    });
    function $c89f04cac0ca9284$var$getModalState() {
      return window.MBF && typeof window.MBF === "object" ? window.MBF : null;
    }
    function $c89f04cac0ca9284$export$b6ddc94bcaaa5fb() {
      const state = $c89f04cac0ca9284$var$getModalState();
      const isInitialised = Boolean(state?.modalOrchestratorInitialised);
      if (isInitialised) return {
        ready: true,
        reason: null
      };
      return {
        ready: false,
        reason: "modal-orchestrator-not-initialized"
      };
    }
  });
  var $9e4lR = parcelRequire("9e4lR");
  var $hdTUn = parcelRequire("hdTUn");
  var $d985df96c6542bf2$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("ajax-modal")) customElements.define("ajax-modal", class AjaxModal extends HTMLElement {
      button=this.querySelector("a");
      url=this.button?.href;
      view=this.dataset.view;
      debugOpen=this.hasAttribute("data-debug-open");
      delay=0;
      getSourceId() {
        const explicitSourceId = this.dataset.sourceId || this.button?.dataset.sourceId;
        if (explicitSourceId) return explicitSourceId;
        if (this.id) return this.id;
        if (this.button?.id) return this.button.id;
        try {
          const path = new URL(this.url, window.location.origin).pathname;
          const slug = path.split("/").filter(Boolean).join("-") || "unknown";
          return `ajax-modal-${slug}-${this.view || "default"}`;
        } catch {
          return `ajax-modal-${this.view || "default"}`;
        }
      }
      getTargetIndex() {
        if (this.hasAttribute("data-index")) return Number.parseInt(this.dataset.index);
        if (this.hasAttribute("data-index-auto")) {
          let activeIndex = null;
          const parentSlider = this.closest("slider-component");
          parentSlider?.dispatchEvent(new CustomEvent("slider:get-state", {
            detail: {
              callback: state => {
                activeIndex = state.activeIndex;
              }
            }
          }));
          return activeIndex;
        }
        return null;
      }
      loadStart() {
        if (!this.button) return;
        this.button.setAttribute("aria-busy", "true");
        this.button.setAttribute("aria-disabled", "true");
      }
      loadEnd() {
        if (!this.button) return;
        this.button.setAttribute("aria-busy", "false");
        this.button.setAttribute("aria-disabled", "false");
      }
      buildRequestUrl() {
        const url = new URL(this.url, window.location.origin);
        if (this.view) url.searchParams.set("view", this.view);
        return url;
      }
      waitForModalResult(requestId) {
        return new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            cleanup();
            reject(new Error(`[ajax-modal] Timed out waiting for modal request ${requestId}`));
          }, 1e4);
          const onOpened = event => {
            if (event.detail?.requestId !== requestId) return;
            cleanup();
            resolve(event.detail);
          };
          const onFailed = event => {
            if (event.detail?.requestId !== requestId) return;
            cleanup();
            reject(event.detail?.error || new Error("[ajax-modal] Modal open failed"));
          };
          const cleanup = () => {
            clearTimeout(timeout);
            window.removeEventListener((0, $9e4lR.MODAL_OPENED_EVENT), onOpened);
            window.removeEventListener((0, $9e4lR.MODAL_OPEN_FAILED_EVENT), onFailed);
          };
          window.addEventListener((0, $9e4lR.MODAL_OPENED_EVENT), onOpened);
          window.addEventListener((0, $9e4lR.MODAL_OPEN_FAILED_EVENT), onFailed);
        });
      }
      async openModal(targetIndex) {
        this.loadStart();
        const url = this.buildRequestUrl();
        const requestId = (0, $9e4lR.createModalRequestId)();
        try {
          const readiness = (0, $hdTUn.getModalOrchestratorReadiness)();
          if (!readiness.ready) {
            const message = `[ajax-modal] Cannot open modal: ${readiness.reason}`;
            console.error(message, {
              requestId: requestId,
              url: url.toString(),
              reason: readiness.reason
            });
            return;
          }
          window.dispatchEvent(new CustomEvent((0, $9e4lR.MODAL_OPEN_REQUEST_EVENT), {
            detail: {
              requestId: requestId,
              baseUrl: url.toString(),
              view: this.view,
              strategy: "replace",
              context: "ajax-modal",
              source: {
                type: "ajax-modal",
                id: this.getSourceId(),
                triggerId: this.button?.id || null,
                context: this.dataset.context || "ajax-modal"
              }
            }
          }));
          const {modalId: modalId} = await this.waitForModalResult(requestId);
          if (targetIndex !== null) {
            const syncSlider = () => {
              const modalSlider = document.querySelector(`[data-locker-container="${modalId}"] slider-component`);
              modalSlider?.dispatchEvent(new CustomEvent("slider:goto", {
                detail: {
                  index: targetIndex
                }
              }));
            };
            setTimeout(syncSlider, this.delay);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.loadEnd();
        }
      }
      connectedCallback() {
        if (!this.url) return;
        this.button.addEventListener("click", async event => {
          event.preventDefault();
          if (this.button.getAttribute("aria-busy") === "true") return;
          const targetIndex = this.getTargetIndex();
          await this.openModal(targetIndex);
        });
        if (this.debugOpen) this.openModal(this.getTargetIndex());
      }
    });
  })();
})();